// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"461":"e227586b","527":"e227586b","732":"e227586b","828":"e227586b"}[chunkId] + ".chunk.css";
};